import { createFileRoute } from '@tanstack/react-router';

import { ErrorLayout } from '@/components/ErrorLayout';

export const Route = createFileRoute('/error/404')({
  component: RouteComponent,
});

export function RouteComponent() {
  return (
    <ErrorLayout
      code="404"
      title="Page introuvable"
      description="La page que vous cherchez n’existe pas ou a été déplacée."
      image="/assets/images/error-404.png"
      cta={{ label: "Retour à la page d'accueil", to: '/' }}
    />
  );
}
